export const viewStageGroup = 'group-stage'
export const viewRanking = 'ranking'


export const positionTabs = [
    {label: 'eventodeportivo_tablaposiciones_texto_titulo_fasegrupos', maxCharacteres: 19, id: viewStageGroup},
    {label: 'eventodeportivo_tablaposiciones_texto_titulo_ranking', maxCharacteres: 19, id: viewRanking}
]


// WEBPACK FOOTER //
// ./src/containers/Mundial2026/TablaDePosiciones/constants.js